<template lang="pug">
div(class="modal fade", id="integration-items", tabindex="-1", role="dialog", data-backdrop="static")
    div(class="modal-dialog", role="document", v-if="hasProvider")
        div.modal-content
            div.modal-header.dark
                button(type="button", class="close", data-dismiss="modal", aria-label="Close")
                    span(aria-hidden="true")
                h4.modal-title Import data from {{ provider.display_name }}
            div.modal-body
                div.box
                    table.table
                        tbody
                            tr(v-for="integration in provider.integration_items")
                                td
                                    label(
                                        class="md-check m-r-sm",
                                        v-show="!isSync(integration.item.name) && !isCompletedSync(integration.item.name)"
                                    )
                                        input(
                                            :name="integration.item.name",
                                            v-model="items",
                                            :disabled="integrationProcessing",
                                            type="checkbox",
                                            :value="integration.item.name",
                                            class="has-value"
                                        )
                                        i.indigo

                                    i(
                                        class="fa fa-spinner fa-spin m-r-sm",
                                        aria-hidden="true",
                                        v-if="isSync(integration.item.name)"
                                    )

                                    i(
                                        class="material-icons md-36 m-r-sm text-dark",
                                        v-html="getItemIcon(integration.item.name)"
                                    )

                                    span {{ integration.item.display_name }}
                                td.text-right.text-nowrap
                                    small.text-muted.m-r-sm Last sync : {{ getLastSync(integration) }}

                p(v-if="integrationProcessing", class="text-center")
                    | Item is being processed. This might takes a few minutes to complete.

            div.modal-footer
                button(
                    type="button",
                    class="btn btn-default",
                    data-dismiss="modal",
                    :disabled="integrationProcessing"
                ) Close
                
                button(
                    type="button",
                    class="btn primary",
                    :disabled="!hasItems || integrationProcessing",
                    @click="submit"
                ) Import
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
    props: {
        provider: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            items: [],
        };
    },

    computed: {
        hasProvider() {
            return this.provider != null;
        },

        hasItems() {
            return this.items.length > 0;
        },

        ...mapState('provider', ['importItems', 'integrationProcessing']),
    },

    watch: {
        items(newVal) {
            this.setImportItems(newVal);
        },
    },

    methods: {
        getLastSync(integration_item) {
            if (integration_item.last_sync == null) return 'Never';

            if (integration_item.last_sync instanceof moment)
                return integration_item.last_sync.fromNow();

            return moment(integration_item.last_sync).fromNow();
        },

        isSync(item) {
            return this.items.indexOf(item) > -1 && this.integrationProcessing;
        },

        isCompletedSync(item) {
            let inItems = this.items.indexOf(item) > -1;
            let notInImportItems = this.importItems.indexOf(item) < 0;

            return inItems && notInImportItems && this.integrationProcessing;
        },

        getItemIcon(item_name) {
            if (item_name == 'outlet') {
                return '&#xE563;';
            }

            if (item_name == 'product') {
                return '&#xE8CB;';
            }
        },

        submit() {
            this.processImportItems();
        },

        ...mapActions('provider', ['processImportItems', 'setImportItems']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/integration/integrations-item.vue